import React from 'react';

import './index.scss';

//materila-ui
import { CircularProgress, Button, Dialog, DialogActions, DialogContent, DialogTitle, createMuiTheme, MuiThemeProvider } from '@material-ui/core';

//api
import {api} from '../../../functions/api';

//custom components
import CustomInput from '../../../components/basic/input'
import CustomButton from '../../../components/basic/CustomButton';

//other libraries
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';

const TIMEOUT = 500

const theme = createMuiTheme ({
    typography: {
        useNextVariants: true
    },
    overrides: {
        // MuiDialogContent: {
        //     root: {
        //         overflow: "initial",
        //         overflowY: "initial"
        //     }
        // },
        // MuiDialogActions: {
        //     root: {
        //         overflow: "initial"
        //     }
        // }
        MuiDialog: {
            paper: {
                overflow: "hidden !important"
            }
        }
    }
})

@inject('internal')
@inject('translate')
@observer
export default class AddEditWeightCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            openSnackbar: false,
            message: "",
            weight_categories: [],
            loadingBtn: false,
        }
    }

    componentDidMount() {
        this.loadCategories();
    }

    formatMoney = (data) => {
        const formatter = new Intl.NumberFormat('sk-SK', {
            // style: 'currency',
            // currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })
        return formatter.format(data)
    }

    loadCategories = async() => {
        this.setState({loading: true})
        let idDeliveryType = toJS(this.props.internal.actionEdit2.id)
        
        let load_delivery_type = await api({
            method: 'get',
            url: `lists/delivery-types/${idDeliveryType}`,
            authorization: this.props.internal.user.access_token,
            
        });

        this.setState({
            weight_categories: load_delivery_type.data.data.weight_categories
        })
        this.setState({loading: false})
        
    }

    updateCategory = async() => {
        this.setState({loadingBtn: true})
        let idDeliveryType = toJS(this.props.internal.actionEdit2.id)

        let resultArray = []
        
        for(let i in this.state.weight_categories) {
            if(this.state.weight_categories[i].weight_from && this.state.weight_categories[i].price) {
                let tmp = {
                    weight_from: Number(this.state.weight_categories[i].weight_from),
                    price: parseFloat(this.state.weight_categories[i].price),
                }
                resultArray.push(tmp)
            }
            
        }
        
        let update_weight_categories = await api({
            method: 'patch',
            url: `lists/delivery-types/${idDeliveryType}/weight-categories`,
            authorization: this.props.internal.user.access_token,
            params: {
                items: resultArray
            }
            
        });

        if(update_weight_categories.success === true) {
            this.setState({loadingBtn: false})
            this.props.internal.setSnackbar(update_weight_categories.data.message, true)
            this.props.onClose();
        }
        else {
            let resultError = "";
            if(update_weight_categories.data.data.errors) {
                for(let error in update_weight_categories.data.data.errors){
                    resultError += update_weight_categories.data.data.errors[error] + " "
                }
            }
            this.props.internal.setSnackbar( resultError, true)
            this.setState({loadingBtn: false})
        }
    }

    weight_before_change = null
    price_before_change = null

    handleChangeRow = (index) => {

        let weight_from = this[`weight_from_${index}`].state.value
        let price = this[`price_${index}`].state.value
        
        let weight_categories = this.state.weight_categories;

        if(weight_from === "" && price === "") {
            clearTimeout(this.timeout)
            this.setState({loading: true})
            this.timeout =  setTimeout(() => {
                weight_categories.splice(index,1)
                this.setState({loading: false})
            }, TIMEOUT)
            
            
        }

        weight_categories[index].weight_from = weight_from;
        weight_categories[index].price = parseFloat(price);
        // weight_categories[index].weight_from = parseFloat(weight_from);
        // let tmpPrice = price.replace(/[^0-9\,]/g,'')
        // let tmpPrice = price.replace(/^[+-]?\d+(\.\d+)?$/,'')
        
        // weight_categories[index].price = parseFloat(tmpPrice.replace(",", "."))

        clearTimeout(this.timeout)
        this.timeout =  setTimeout(() => {
            this.setState({loading: true})
            weight_categories.sort((a, b) => a.weight_from - b.weight_from)
            this.setState({loading: false})
            
        }, 2000)

        this.setState({weight_categories: weight_categories})
    }

    createNewCategory = () => {
        let resultArray = []
        for(let i in this.state.weight_categories) {
            let tmp = {
                weight_from: parseFloat(this.state.weight_categories[i].weight_from),
                price: parseFloat(this.state.weight_categories[i].price),
            }
            resultArray.push(tmp)
        }

        clearTimeout(this.timeout)
        if(this.weight.state.value !== "" && this.price.state.value !== "") {
            
            this.timeout =  setTimeout(() => {
                this.setState({weight_categories: []})
                resultArray.push(
                    {
                        weight_from: parseFloat(this.weight.state.value),
                        price: parseFloat(this.price.state.value)
                    }
                )
                resultArray.sort((a, b) => a.weight_from - b.weight_from)
                this.setState({weight_categories: resultArray});
                this.weight.setValue("");
                this.price.setValue("");
                document.getElementById('weight').focus()
            }, TIMEOUT)

        }
    }

    render() {
        return (
            <MuiThemeProvider theme={theme}>
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"

            >
            
                <DialogTitle id="form-dialog-title">{this.props.title}</DialogTitle>
                <DialogContent className={'dialog-delivery_types'}>
                {this.state.loading
                    ?
                    <CircularProgress className={'circular-progress'} />
                    :
                        <div className={'flex edit-weight-category flex-column'}>
                            <div className={'flex w-100 column-titles'}>
                                <span className={'flex'}>{this.props.translate.i18n.MODULES.TRANSPORTS.WEIGHT}</span>
                                <span className={'flex '}>{this.props.translate.i18n.MODULES.TRANSPORTS.PRICE}</span>
                            </div>
                        {this.state.weight_categories.length ? this.state.weight_categories.map((category, index) => {
                            return (
                                <div key={index} className={'flex w-100'} onKeyUp={() => this.handleChangeRow(index)} >
                                    <CustomInput
                                        ref={ref => {this[`weight_from_${index}`] = ref}}
                                        value={this.state.weight_categories  ? `${Number.parseInt(this.state.weight_categories[index].weight_from, 10)}` : ""}
                                        id={'weight_from'}
                                        className={"mr-10 w-50 text-right"}
                                        startAdornment={{position: "start", value: "Od"}}
                                        endAdornment={{position: "end", value: "kg"}}
                                    />
                                    <CustomInput
                                        ref={ref => {this[`price_${index}`] = ref}}
                                        value={this.state.weight_categories ? this.formatMoney(this.state.weight_categories[index].price) : ""}
                                        id={'price'}
                                        className={"w-50 text-right"}
                                        endAdornment={{position: "end", value: "€"}}
                                    />
                                </div>
                                
                            )})
                            :
                            null
                            }
                            <div className={'flex w-100'} onKeyUp={this.createNewCategory}>
                                <CustomInput
                                    ref={ref => this.weight = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.WEIGHT}
                                    value={""}
                                    id={'weight'}
                                    className={"mr-10 w-50"}
                                    autoFocus={true}
                                    // startAdornment={{position: "start", value: "Od"}}
                                    endAdornment={{position: "end", value: "kg"}}
                                />
                                <CustomInput
                                    ref={ref => this.price = ref}
                                    text={this.props.translate.i18n.MODULES.TRANSPORTS.PRICE}
                                    value={ ""}
                                    id={'price'}
                                    className={"w-50"}
                                    endAdornment={{position: "end", value: "€"}}
                                />
                            </div>

                        </div>
                    
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {/* <Button onClick={this.updateCategory} className={'orange-text'}>
                        {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}
                    <CustomButton
                            progressBar={this.state.loadingBtn}
                            onClick={this.updateCategory}
                            mystyle={'btn-white-bg'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                            disabled={this.state.loading}
                            justText
                        />
                </DialogActions>
                
            </Dialog>
            </MuiThemeProvider>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/delivery/AddEditWeightCategory/index.js